export const numDecorator = {
  props: {
    decorateNumerals: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    numLocaleDecorator (value) {
      if (!this.decorateNumerals) { return value }
      // eslint-disable-next-line eqeqeq
      if (parseFloat(value) != value) {
        return value
      }
      return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5
      })
    },
    confNums (x, precision, thousandSeparator = '') {
      const parts = x.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)
      if (parts.length === 1) {
        if (precision > 0) { parts[1] = '0'.repeat(precision) }
      } else {
        if (parts[1].length < precision) {
          parts[1] = parts[1].concat('0'.repeat(precision - parts[1].length))
        } else {
          parts[1] = parts[1].substr(0, precision)
        }
      }
      return precision === 0 ? parts[0] : parts.join('.')
    }
  },
  watch: {},
  computed: {}
}
